import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type { InsertDocumentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDocumentDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { FrontendRouterInputs } from '../routerInputs';
import type { InsertDocumentInput } from '../scheduledEntityInputs';

type InsertDocumentTRPCInput = FrontendRouterInputs['document']['insert'];

export const useInsertDocument = createMutationHook({
  name: 'insertDocument',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.document.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: ({
    schedule,
    ...rest
  }: InsertDocumentInput): InsertDocumentTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
  }),
  invalidate: (trpc) => [
    trpc.frontend.document.register.queryKey(),
    trpc.frontend.document.documentById.queryKey(),
    trpc.frontend.document.list.queryKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  mapResponse: (result: { Id: string }): InsertDocumentMutation => ({
    insertChildDocument: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertDocumentDocument,
  graphqlVariables: (input: InsertDocumentInput) => ({ object: input }),
  evictFields: ['document'],
});
